import React from 'react';
import { CheckIcon } from 'lucide-react';
/**
 * Centered success modal — used after password reset and account creation.
 */
export function SuccessModal({
  open,
  title,
  message,
  ctaLabel = 'Continue',
  onConfirm
}: {
  open: boolean;
  title: string;
  message: string;
  ctaLabel?: string;
  onConfirm: () => void;
}) {
  if (!open) return null;
  return <div className="absolute inset-0 z-30 flex items-end sm:items-center justify-center px-5 pb-6" style={{
    backgroundColor: 'rgba(15, 23, 42, 0.45)'
  }} role="dialog" aria-modal="true" data-id="element-678">
      <div className="w-full rounded-3xl bg-white px-6 pt-7 pb-6 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.35)]" style={{
      maxWidth: 340
    }} data-id="element-679">
        <div className="flex justify-center mb-5" data-id="element-680">
          <div className="flex items-center justify-center rounded-full" style={{
          width: 76,
          height: 76,
          backgroundColor: '#E6F7FB'
        }} data-id="element-681">
            <div className="flex items-center justify-center rounded-full" style={{
            width: 56,
            height: 56,
            backgroundColor: '#009AC7'
          }} data-id="element-682">
              <CheckIcon size={32} color="#FFFFFF" strokeWidth={3} data-id="element-683" />
            </div>
          </div>
        </div>
        <h2 className="text-center tracking-tight" style={{
        fontSize: 20,
        fontWeight: 700,
        color: '#1A1A1A',
        lineHeight: 1.3
      }} data-id="element-684">
          {title}
        </h2>
        <p className="mt-2 text-center" style={{
        fontSize: 14,
        color: '#525252',
        lineHeight: 1.65
      }} data-id="element-685">
          {message}
        </p>
        <button type="button" onClick={onConfirm} className="mt-6 w-full rounded-2xl text-white font-semibold transition-all active:scale-[0.99]" style={{
        backgroundColor: '#009AC7',
        minHeight: 56,
        fontSize: 16,
        boxShadow: '0 10px 24px -10px rgba(0, 154, 199, 0.55)'
      }} data-id="element-686">
          {ctaLabel}
        </button>
      </div>
    </div>;
}